import { CornerVariants } from './types';

export const Corners: Record<CornerVariants, string> = {
  small: '2px',
  medium: '4px',
  large: '8px',
  extraLarge: '16px',
  full: '100%',
};
